import AgenliteAPIClient from '~/api/index';

const initialState = {
  qriscode: {},
};

const getters = {
  getQrisCode(state) {
    return state.qriscode;
  },
  qrisEnabled(state) {
    return state?.qriscode?.status !== 'REJECTED';
  },
};

const actions = {
  async retrieveQrisCode({ commit }) {
    try {
      const response = await AgenliteAPIClient.getQrisCode();
      commit('setQrisCode', response.data);
    } catch (error) {
      const message = 'Gagal mendapatkan data';
      throw new Error(message);
    }
  },
};

const mutations = {
  setQrisCode(state, qriscode) {
    state.qriscode = qriscode;
  },
};

export default {
  state: () => ({ ...initialState }),
  mutations,
  getters,
  actions,
};
